// extracted by mini-css-extract-plugin
export default {"avatar":"FwDkj90ZA9","preview":"ZdGL4WnXej"};